<template>
</template>

<script>
export default {
  data() {
    return {
    };
  },

  // components: {},

  // computed: {},

  // mounted: {},

  // methods: {}
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";

</style>




// WEBPACK FOOTER //
// src/components/Guarantee.vue